module.exports = __webpack_public_path__ + "static/downloadApp-0baf08c2c0d3050e910a2ea0eb29ea8b.png";